// matches resi-toolkit-core breakpoints.scss
export const MEDIUM_WIDTH = 768
